<template>
  <v-list class="py-0" flat>
    <v-tooltip location="end" color="primary">
      <template #activator="{ props: tooltipProps }">
        <v-hover v-slot="{ isHovering, props: hoverProps }">
          <v-list-item
            :class="[{ 'px-0 justify-center': isMiniSidebarShown }, 'mx-4 py-0 px-3']"
            v-bind="{ ...isTooltipShown(tooltipProps), ...hoverProps }"
            @click="downloadPwa()"
          >
            <v-list-item-action
              :class="['d-flex justify-center align-center', { 'mr-3': !isMiniSidebarShown }]"
            >
              <v-icon
                size="18"
                :class="{ 'opacity-60': !isHovering }"
                :color="isHovering ? 'primary' : 'white'"
              >
                mdi-download
              </v-icon>
            </v-list-item-action>
            <v-list-item-title
              :class="{ 'opacity-60': !isHovering }"
              class="custom-title text-white"
            >
              PWA
            </v-list-item-title>
          </v-list-item>
        </v-hover>
      </template>

      <span>PWA</span>
    </v-tooltip>
  </v-list>
</template>

<script>
  import { mapState } from 'pinia'
  import { useSettingsStore } from '@/store/settings/settings'

  export default {
    name: 'InstallPwa',
    computed: {
      ...mapState(useSettingsStore, ['isMiniSidebarShown'])
    },
    methods: {
      downloadPwa() {
        // :TODO vue3
        // this.$pwa.prompt()
      },
      isTooltipShown(props) {
        return this.isMiniSidebarShown ? props : {}
      }
    }
  }
</script>
